import { createContext, useContext, useState, useEffect } from "react";
import { fetchBucketUrl, fetchUserDataAPI, fetchCategoriesAPI, fetchDeveloperInfo } from "../utils/api";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [bucketURLS, setBucketURLS] = useState({});
    const [developerInfo, setDeveloperInfo] = useState(null);

    // Function to refresh developer info
    const refreshDeveloperInfo = async () => {
        try {
            const dev = await fetchDeveloperInfo();
            if (dev) setDeveloperInfo(dev);
            return dev;
        } catch (err) {
            console.error("Error fetching developer info", err);
        }
    };

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const userResponse = await fetchUserDataAPI();
                if (userResponse?.is_authenticated) {
                    setUserData(userResponse);
                }

                const categoriesResponse = await fetchCategoriesAPI();
                if (categoriesResponse) {
                    setCategoriesData(categoriesResponse);
                }

                const urls = await fetchBucketUrl("");
                setBucketURLS(urls);

                await refreshDeveloperInfo();
            } catch (err) {
                console.error(err);
            }
        };
        fetchAll();
    }, []);

    return (
        <GlobalContext.Provider
            value={{
                userData,
                categoriesData,
                bucketURLS,
                developerInfo,
                refreshDeveloperInfo,   
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};

export const useGlobal = () => useContext(GlobalContext);
